export default __webpack_public_path__ + "85d8b36556546d4999221e73c82f524c.png";